import AOS from "aos";
import lax from "lax.js";

(function ($) {
  //on document ready scripts start
  $(function () {
    //toggleText Function
    $.fn.extend({
      toggleText: function (a, b) {
        return this.text(this.text() == b ? a : b);
      },
    });

    //sticky js
    const stickySiteHeader = $(".site-header").sticky({
      zIndex: 1000,
    });
    $(window).on("resize", function () {
      stickySiteHeader.sticky("update");
    });

    //Mobile sub menu toggle
    $(".sub-menu-toggle").on("click", function () {
      $(this).toggleText("expand_more", "expand_less").next().slideToggle(300);
    });

    // Slick carousel
    $(".site-carousel").slick({
      prevArrow:
        '<button type="button" class="slick-prev"><span class="slick-arrow__icon material-icons">chevron_left</span></button>',
      nextArrow:
        '<button type="button" class="slick-next"><span class="slick-arrow__icon material-icons">chevron_right</span></button>',
    });

    //Accordion
    $(".accordion__button").on("click", function () {
      $(this).removeClass("on");
      $(this).next().slideUp("normal");
      if ($(this).next().is(":hidden") == true) {
        $(this).addClass("on");
        $(this).next().slideDown("normal");
      }
    });
    $(".accordion__content").hide();

    //IE Message
    if (window.document.documentMode) {
      var currentDiv = document.getElementById("site-body");
      currentDiv.insertAdjacentHTML(
        "afterbegin",
        '<div class="ie-message">⚠️You are using an outdated Internet Explorer browser. For a faster, safer browsing experience, upgrade for FREE today! <a href="https://www.microsoft.com/en-us/edge" target="_blank" class="btn">Upgrade</a></div>'
      );
    }

    // scroll to anchor
    $("a").on("click", function (e) {
      let target = this.hash;
      let $target = $(target);
      let excludeHeader = $(this).hasClass("exclude-header");
      if (target && $target.length) {
        e.preventDefault();
        $("html, body")
          .stop()
          .animate(
            {
              scrollTop: excludeHeader
                ? $target.offset().top
                : $target.offset().top - 5 * 16,
            },
            900,
            "swing"
          );
      }
    });

    //scroll to anchor
    $(".scroll-down").on("click", function (e) {
      e.preventDefault();
      $("html, body")
        .stop()
        .animate(
          {
            scrollTop:
              $(this).offset().top +
              $(this).outerHeight()
          },
          500,
          "swing"
        );
    });

    $(".circle-nav__li").click(function (index) {
      let activeClass = "circle-nav__li--active";
      if (!$(this).hasClass(activeClass)) {
        let itemIndex = $(this).index();
        let itemIndexTab = itemIndex + 1;
        $(".circle-nav__li").removeClass(activeClass);
        $(this).addClass(activeClass);
        $(".circle-nav__indicator").attr(
          "data-indicator-position",
          itemIndex
        );
        $(".tab__content").hide(300)
        $(".tab__content:nth-child(" + itemIndexTab + ")").show(300);
      }
    });
    $('.tab__content:first').show();

    //Sections
    let siteSection = ".site-section";

    $(siteSection).each(function (index) {
      $(this).attr("data-scroll-index", index);
      let title = $(this).data("section-title");
      $(".site-menu").append(
        "<li><a class='site-menu__link' data-scroll-nav=" + index + ">" + title + "</a></li>"
      );
    });

    //Scrollit.js
    $.scrollIt({
      activeClass: "is-active",
      topOffset: -($(".site-header").height() - 20),
    });
    
    //view mobile menu
    function toggleSiteMenu() {
      $(".overlay-menu").toggleClass("overlay-menu--visible");
      $(".site-curtain--menu").fadeToggle(200);
      $("html").toggleClass("is-locked");
    }
    $(".site-menu-toggle, .site-curtain--menu, .site-menu__link").on("click", function () {
      toggleSiteMenu();
    });

    //Animation on scroll
    AOS.init({
      once: true,
      duration: 1000,
      offset: 70,
    });
  }); //on document ready scripts END
})(jQuery, this);


lax.init()
lax.addDriver('scrollY', function () {
  return window.scrollY
})

lax.addElements('.lax-img', {
  scrollY: {
    translateX: [
      ["elInY", "elOutY"],
      ['-screenWidth/50', 'screenWidth/50'],
    ],
    scale: [
      ["elInY"],
      [1.2]
    ]
  }
});

lax.addElements('.row__text-decorated', {
  scrollY: {
    translateX: [
      ["elInY", "elOutY"],
      ['screenWidth/60', '-screenWidth/60'],
    ]
  }
})

